import { LoginSessionType } from '@/constants/login'
import { paths } from '@/constants/paths'
import { Auth } from '@/containers/Auth/Auth'
import { EmptyScreen } from '@/containers/EmptyScreen/EmptyScreen'
import { Error } from '@/containers/Error'
import { EventDetailPageWithSidebar } from '@/containers/EventDetailPage/EventDetailPageWithSidebar'
import { ExitScreen } from '@/containers/ExitScreen'
import { FeatureScreen } from '@/containers/FeatureScreen/FeatureScreen'
import { Page } from '@/containers/Page/Page'
import { MainLayout } from '@/layouts/MainLayout'
import { SettingsLayout } from '@/layouts/SettingsLayout'

import { mainLayoutRoutes } from './mainLayoutRoutes'
import { settingsRoutes } from './settingsRoutes'

export type RouteConfig = {
  path: string
  index?: boolean
  element: JSX.Element
  children?: RouteConfig[]
}

export const routes: RouteConfig[] = [
  {
    path: paths.ROOT,
    element: <MainLayout />,
    children: mainLayoutRoutes,
  },
  {
    path: paths.SETTINGS,
    element: <SettingsLayout />,
    children: settingsRoutes,
  },
  {
    path: paths.EVENT_PAGE,
    element: <EventDetailPageWithSidebar />,
    children: [
      {
        path: ':id',
        element: <EventDetailPageWithSidebar />,
      },
    ],
  },
  {
    path: paths.PAGE,
    element: <Page />,
    children: [
      {
        path: ':id',
        element: <Page />,
      },
    ],
  },
  {
    path: `${paths.FAVORITES}/:id`,
    element: <Page />,
  },
  {
    path: paths.EMPTY,
    element: <EmptyScreen />,
  },
  {
    path: paths.FEATURE_SCREEN,
    element: <FeatureScreen />,
  },
  {
    path: paths.EXIT,
    element: <ExitScreen />,
  },
  {
    path: paths.LOGIN,
    element: <Auth sessionType={LoginSessionType.LOGIN} />,
  },
  {
    path: paths.REGISTER,
    element: <Auth sessionType={LoginSessionType.REGISTER} />,
  },
  {
    path: paths.CHECKOUT,
    element: <Auth sessionType={LoginSessionType.CHECKOUT} />,
  },
  {
    path: paths.SELF_SERVICE,
    element: <Auth sessionType={LoginSessionType.SELF_SERVICE} />,
  },
  {
    path: paths.ERROR,
    element: <Error />,
  },
]
